(function() {
    $(document).ready(function() {

        if (window.c24LpIsApp) {
            return;
        }

        const backToTop = $('.js24BackToTop');
        if (!backToTop.length) {
            return;
        }

        const minScrollTop = 110;
        const minWidth = 1750;

        if ($(window).width() < minWidth) {
            backToTop.hide();
        }

        backToTop.on('click', function() {
            $('html').stop().animate({
                'scrollTop': 0,
            });
        });

        document.addEventListener('scroll', function() {
            if ($(window).scrollTop() < minScrollTop) {
                backToTop.stop().fadeOut('fast');
            } else {
                backToTop.stop().fadeIn('fast');
            }
        }, {
            passive: true,
        });

        $(window).resize(function() {
            if ($(window).width() < minWidth) {
                backToTop.stop().fadeOut('fast');
            } else {
                backToTop.stop().fadeIn('fast');
            }
        });
    });
})();
